import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as KeyRequestsState from "../../store/KeyRequests";
import { confirmPrompt } from "../../helpers";
import SelectLock from "../shared/SelectLock";
import {
  LockResponse,
  KeyRequestCredentialType,
  GuestKeyRequestResponse,
} from "../../api/ApiClient";
import { useState, useEffect, useRef, useCallback } from "react";
import queryString from "query-string";
import MyAlerts, { MyAlertsRef } from "../shared/Alert";

type OwnProps = {
  header?: string;
};

const OpenDoor: React.FC<OwnProps> = ({ header = "Open Door" }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const myAlertsRef = useRef<MyAlertsRef | null>(null);

  const [inProgress, setInProgress] = useState<Record<string, boolean>>({});
  const [credentialType] = useState<KeyRequestCredentialType>(
    KeyRequestCredentialType.RemoteOpen,
  );

  const setMyAlerts = (myAlerts: MyAlertsRef) => {
    myAlertsRef.current = myAlerts;
  };

  const doOpenDoor = useCallback(
    (lock: LockResponse) => {
      confirmPrompt({
        promptMessage: "Are you sure you want to open '" + lock.name + "'?",
        onConfirm: async () => {
          setInProgress((prev) => ({
            ...prev,
            [lock.id || ""]: true,
          }));

          try {
            const json = await (dispatch as any)(
              KeyRequestsState.actionCreators.postKeyRequest({
                lockIds: [lock.id || ""],
                credentialType,
              }),
            );
            const info = (json as any as GuestKeyRequestResponse)
              .tokenOrSecretInstruction;

            myAlertsRef.current &&
              myAlertsRef.current.addApiSuccessAlert(
                info ? info : "Successfully opened door",
                { dismissAfterMs: info ? undefined : 5000 },
              );
          } catch (e) {
            myAlertsRef.current && myAlertsRef.current.addApiErrorAlert(e);
          } finally {
            setInProgress((prev) => ({
              ...prev,
              [lock.id || ""]: false,
            }));
          }
        },
      });
    },
    [dispatch, credentialType],
  );

  useEffect(() => {
    const { unitId, unitName } = queryString.parse(location.search || "");
    if (unitId) {
      doOpenDoor({
        id: unitId as string,
        name: unitName as string,
      } as LockResponse);
    }
  }, [location.search, doOpenDoor]);

  const inProgressLocks = Object.keys(inProgress)
    .filter((k) => inProgress[k])
    .map((k) => ({ id: k }) as LockResponse);

  return (
    <div>
      <h3>{header}</h3>
      <hr />
      <MyAlerts ref={setMyAlerts} />
      <form>
        {
          //@ts-ignore
          <SelectLock
            onSelected={doOpenDoor}
            inProgressLocks={inProgressLocks}
            inProgressLabel="Opening..."
            btnStyle={{ width: 130 }}
            unselectedLabel="Open"
            unselectedBtnClass="btn-primary"
          />
        }
      </form>
    </div>
  );
};

export default OpenDoor;
